import state from './state'
export default {
  state,
  mutations: {
    setOfferAcceptedInfo(state, infoObj) {
      state.offerAcceptedInfo = infoObj
    },
    setUserName(state, userName) {
      state.userName = userName
    },
    setPersonInfo(state, personInfo) {
      state.personInfo = personInfo
    },
    setBaseUrl(state, baseUrl) {
      state.baseUrl = baseUrl
    },
    /**
     * 保存路径参数
     * @param {Object} obj 路径参数对象 
     */
    setUrlAttr(state, obj) {
      obj.loginType && (state.urlLoginType = obj.loginType)
      obj.code && (state.urlCode = obj.code)
      obj.channel && (state.urlChannel = obj.channel)
      obj.state && (state.urlState = obj.state)
    },
    setNoSeason(state, bool) {
      state.glNoSeason = bool
    },
    setSearchValue(state, value) {
      state.searchValue = value
    }
  },
  actions: {},
  getters: {}
}


// WEBPACK FOOTER //
// ./src/store/global/index.js